import merge from 'lodash/merge';
import { enUS as enUSAdapter, sv as svSEAdapter } from 'date-fns/locale';
// core
import { enUS as enUSCore, svSE as svSECore } from '@mui/material/locale';
// date-pickers
import { enUS as enUSDate, svSE as svSEDate } from '@mui/x-date-pickers/locales';
// data-grid
import { enUS as enUSDataGrid, svSE as svSEDataGrid } from '@mui/x-data-grid';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Swedish',
    value: 'sv',
    systemValue: merge(svSEDate, svSEDataGrid, svSECore),
    adapterLocale: svSEAdapter,
    icon: 'flagpack:se',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
];

export const defaultLang = allLangs[0]; // Swedish

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
